import { useCallback, useEffect, useState } from "react";
import ActivityTab from "./ActivityTab";
import ReservationTab from "./ReservationTab";
import Feed from "./Feed";
import CertificationTab from "./CertificationTab";
import ReviewList from "../review/ReviewList";
import { getMyReviews } from "api/review";

// 리뷰 탭이 선택됐을 때만 마운트되어 데이터를 fetch하도록 별도 컨테이너로 분리.
// (TabWrap에서 바로 fetch하면 다른 탭을 보는 동안에도 API가 호출되어 불필요한 요청이 발생)
const ReviewTabContainer = () => {
    const [reviews, setReviews] = useState([]);
    const [reviewSummary, setReviewSummary] = useState(null);
    const [reviewHasMore, setReviewHasMore] = useState(false);
    const [reviewLoading, setReviewLoading] = useState(false);

    const fetchReviews = useCallback(async () => {
        setReviewLoading(true);
        try {
            const data = await getMyReviews();
            const results = data.results || data || [];
            setReviews(results);
            setReviewSummary(data.summary || null);
            setReviewHasMore(!!data.next);
        } catch {
            // silent
        } finally {
            setReviewLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchReviews();
    }, [fetchReviews]);

    return (
        <ReviewList
            summary={reviewSummary}
            reviews={reviews}
            hasMore={reviewHasMore}
            loading={reviewLoading}
            onLoadMore={fetchReviews}
        />
    );
};

const renderTab = (tabName, onTabChange) => {
    switch (tabName) {
        case "강사관리":
            return <ActivityTab onTabChange={onTabChange} variant="instructor" />;
        case "나의 활동":
            return <ActivityTab onTabChange={onTabChange} variant="activity" />;
        case "예약":
            return <ReservationTab />;
        case "피드":
            return <Feed />;
        case "커뮤니티":
            return <ActivityTab onTabChange={onTabChange} variant="community" />;
        // case "자격증":
        //     return <CertificationTab />;
        // case "리뷰":
        //     return <ReviewTabContainer />;
        default:
            return null;
    }
};

const TabWrap = ({ tabName, onTabChange }) => {
    return (
        <div className="tab-wrap">
            {renderTab(tabName, onTabChange)}
        </div>
    );
};

export default TabWrap;
